export default __webpack_public_path__ + "static/media/modern-components-dark.aa0f485a.png";